import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { intl } from '../../../../modules/Intl/IntlGlobalWrapper';
import textUtils from '../../../../util/text';
import { saveConfig, updateTimeUnit } from '../../FilterActions';
import { CustomSelect } from '../common';

const DEFAULT = [
  { label: 'Day', value: 'day' },
  { label: 'Week', value: 'week' },
  { label: 'Month', value: 'month' }
];

class TimeUnit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: DEFAULT
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    if (!!this.props.chart) {
      this.initializeItems();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!!this.props.chart && prevProps.chart !== this.props.chart) {
      this.initializeItems();
    }
  }

  initializeItems() {
    switch (this.props.chart) {
      case 'ctsp':
      case 'cth':
      case 'cta':
      case 'ddp': {
        const items = [...DEFAULT];
        if (this.props.userConfig && this.props.userConfig.enableHoursGrouping) {
          items.unshift({ label: 'Hour', value: 'hour' });
        }
        this.setState({ items });
        break;
      }
      case 'ctb': {
        const items = [...DEFAULT];
        items.unshift({
          label: textUtils.format(
            intl.formatMessage({ id: `${this.props.app}.card` }),
            '',
            true,
            false,
            'capitalize'
          ),
          value: 'cards'
        });
        items.splice(3, 0, { label: '2 weeks', value: '2weeks' });
        this.setState({ items });
        break;
      }
      case 'cfd':
      case 'trc':
      case 'th': {
        const items = [...DEFAULT];
        items.splice(2, 0, { label: '2 weeks', value: '2weeks' });
        this.setState({ items });
        break;
      }
      default: {
        this.setState({
          items: DEFAULT
        });
        break;
      }
    }
  }

  handleChange(selected) {
    this.props.updateValue(selected, this.props.chart);
    this.props.saveConfig();
  }

  render() {
    const { items } = this.state;

    return (
      <CustomSelect
        name={'timeUnit'}
        title={'Group by'}
        items={items}
        value={this.props.value}
        onSelect={this.handleChange}
      />
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateValue: (val, chart) => dispatch(updateTimeUnit(val, chart))
  };
};

const mapStateToProps = state => {
  let chart = state.filters.chart;
  return {
    app: state.app.app,
    userConfig: state.auth.user.config,
    chart: state.filters.chart,
    value: state.filters[chart].timeUnit
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(TimeUnit);
export { connected as TimeUnit };
